import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    {
        title:'On the Benefits of Defining Vicinal Distributions in Latent Space',
        zoom:"https://illinois.zoom.us/j/85813838638?pwd=eTJEQTZIemJDc1JXTGlKbTdWQ2tZdz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/2.pdf",
    },
    {
        title:"Puneet Mangla (IIT Hyderabad); Vedant Singh (IIT, Hyderabad); Shreyas Havaldar (Indian Institute of Technology Hyderabad); Vineeth Balasubramanian (Indian Institute of Technology Hyderabad)"
    },
    {
        title:"Understanding the Role of Adversarial Regularization in Supervised Learning",
        zoom:"https://illinois.zoom.us/j/88127887998?pwd=WnBVa01seUh5TXZsR3FiWEVCdzZYUT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/5.pdf",
    },
    {
        title: "Litu Rout (Indian Space Research Organisation)"
    },
    {
        title:"A Simple Fine-tuning Is All You Need: Towards Robust Deep Learning Via Adversarial Fine-tuning",
        zoom:"https://illinois.zoom.us/j/87034570144?pwd=cEJBUGdRd0FsdnQxTU5nSUVnamFsZz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/7.pdf",
    },
    {
        title:"Ahmadreza Jeddi (University of Waterloo); Mohammad Javad Shafiee (University of Waterloo); Alexander  Wong (University of Waterloo)"
    },
    {
        title:"Adversarial Evaluation of Multimodal Models under Realistic Gray Box Assumptions",
        zoom:"https://illinois.zoom.us/j/88515932387?pwd=eklTSUh0QjltNkZSQnV1VERTd0Jxdz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/8.pdf",
    },
    {
        title:"Ivan Evtimov (University of Washington Paul G. Allen School of Computer Science & Engineering); Russell Howes (Facebook AI); Brian Dolhansky (Reddit); Hamed Firooz (Facebook); Canton Cristian (Facebook AI)",
    },
    {
        title:"Adversarial collision attacks on image hashing functions",
        zoom:"https://illinois.zoom.us/j/81355379968?pwd=THRENzc0WU1UWlVKS1ZCbXlzbDltQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/9.pdf",
    },
    {
        title:"Brian Dolhansky (Reddit); Canton Cristian (Facebook AI)",
    },
    {
        title:"One Size Does Not Fit All: Transferring Adversarial Attacks Across Sizes",
        zoom:"https://illinois.zoom.us/j/82131996711?pwd=Uys4RzZXK2dYN0NiQjcwNFZOYWthQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/10.pdf",
    },
    {
        title:"Jeremiah Duncan (University of Tennessee); Amir Sadovnik (The University of Tennessee)"
    },
    {
        title:"Anti-Adversarial Input with Self-Ensemble Model Transformations",
        zoom:"https://illinois.zoom.us/j/88543385681?pwd=UVg5SE44eTE4RHZMOU5MTitvMkRuUT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/11.pdf",
    },
    {
        title:"Jeremiah Rounds (Pacific Northwest National Laboratory); Kayla Duskin (PNNL); Michael Henry (Pacific Northwest National Laboratory)"
    },
    {
        title:"Evaluating the Robustness of Bayesian Neural Networks Against Different Types of Attacks",
        zoom:"https://illinois.zoom.us/j/88909838510?pwd=TUovN2h1cTZCanJ2ODYwN0FJckc4dz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/12.pdf",
    },
    {
        title:"Yutian Pang (Arizona State University); Sheng Cheng (Arizona State University); Jueming Hu (Arizona State University); Yongming Liu (Arizona State University)"
    },
    {
        title:"Class retrieval of adversarial attacks",
        zoom:"https://illinois.zoom.us/j/81746136706?pwd=YzFDdmh3emZsRHV4b0M3L3lnclVxQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/13.pdf",
    },
    {
        title:"Jalal Al-afandi (Peter Pazmany Catholic University); Andras Horvath (Peter Pazmany Catholic University)"
    },
    {
        title:"Relating Adversarially Robust Generalization to Flat Minima",
        zoom:"https://illinois.zoom.us/j/88006878374?pwd=c1dTejFmeEZiRE9OTU5ldzgyN3dpUT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/14.pdf",
    },
    {
        title:"David Stutz (Max Planck Institute for Informatics); Matthias Hein (University of Tübingen); Bernt Schiele (MPI Informatics)"
    },
    {
        title:"Bit Error Robustness for Energy-Efficient DNN Accelerators",
        zoom:"https://illinois.zoom.us/j/88006878374?pwd=c1dTejFmeEZiRE9OTU5ldzgyN3dpUT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/15.pdf",
    },
    {
        title:"David Stutz (Max Planck Institute for Informatics); Nandhini Chandramoorthy (IBM T. J. Watson Research Center); Matthias Hein (University of Tübingen); Bernt Schiele (MPI Informatics) [Note: Same Zoom room as the paper above. The same author will discuss this paper in the second half of the session.]"
    },
    {
        title:"Improving Adversarial Transferability with Gradient Refining",
        zoom:"https://illinois.zoom.us/j/82787818275?pwd=WVdPUzljcHFFbVYzZnVGc3hRNmRuZz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/16.pdf",
    },
    {
        title:"Guoqiu Wang (Beihang University)*; Huanqian Yan (Beihang University)*; Ying Guo (Beihang University)*; Xingxing Wei (Beihang University)"
    },
    {
        title:"Adversarial Variance Attacks: Deeper Insights into Adversarial MachineLearning through the Eyes of Bias-Variance Impact",
        zoom:"https://illinois.zoom.us/j/81694401403?pwd=SzZaeXpRa0JreFB5M1NsdHU3bUxiQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/17.pdf",
    },
    {
        title:"Hossein Aboutalebi (University of Waterloo); Mohammad Javad Shafiee (University of Waterloo); Michelle  Karg (ADC Automotive Distance Control Systems GmbH, Continental); Christian Scharfenberger (ADC Automotive Distance Control Systems GmbH, Continental); Alexander  Wong (University of Waterloo)"
    },
    {
        title:"Unrestricted Adversarial Attacks on Vision Transformers",
        zoom:"https://illinois.zoom.us/j/83460776689?pwd=cGxxaVExV29IZkhtdEVXOXZvV3Vidz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/20.pdf",
    },
    {
        title:"Rajat Sahay (Vellore Institute of Technology, Vellore)"
    },
    {
        title:"Residual Error: a New Performance Measure for Adversarial Robustness",
        zoom:"https://illinois.zoom.us/j/85234256737?pwd=ek9XTHBqdk03bHQ4QktZemhzdHk4dz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/23.pdf",
    },
    {
        title:"Hossein Aboutalebi (University of Waterloo); Mohammad Javad Shafiee (University of Waterloo); Michelle  Karg (ADC Automotive Distance Control Systems GmbH, Continental); Christian Scharfenberger (ADC Automotive Distance Control Systems GmbH, Continental); Alexander  Wong (University of Waterloo)"
    },
    {
        title:"Localized Uncertainty Attacks",
        zoom:"https://illinois.zoom.us/j/84765016851?pwd=bm9WRmtKOHpZa01xSkoxTWQ0NTFBQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/26.pdf",
    },
    {
        title:"Ousmane A Dia (Facebook); Theofanis Karaletsos (Facebook); Caner Hazirbas (Facebook AI); Canton Cristian (Facebook AI); Ilknur Kaynar Kabul (Facebook); Erik Meijer (Facebook)"
    },
    {
        title:"Semantics Preserving Adversarial Examples",
        zoom:"https://illinois.zoom.us/j/85741174983?pwd=S3MrSTdjTUVEWTVrQ0pZMkVvMG5PQT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/27.pdf",
    },
    {
        title:"Sanjay Kariyappa (Georgia Institute of Technology); Ousmane A Dia (Facebook)"
    },
    {
        title:"The Triangular Trade-off Between Accuracy, Robustness, and Fairness",
        zoom:"https://illinois.zoom.us/j/87970582070?pwd=eHp4SjhqYldhS2ZLSTdJSkdZcDJZdz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/28.pdf",
    },
    {
        title:"Philipp Benz (KAIST)*; Chaoning Zhang (KAIST)*; Soomin Ham (KAIST); Adil Karjauv (KAIST); Gyusang Cho (KAIST); In So Kweon (KAIST)"
    },
    {
        title:"Robustness Comparison of Vision Transformer and MLP-Mixer to CNNs",
        zoom:"https://illinois.zoom.us/j/83536811479?pwd=eWZCVkhwcXJ1ZitDbFlUaFdwUWRFUT09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/29.pdf",
    },
    {
        title:"Philipp Benz (KAIST)*; Chaoning Zhang (KAIST)*; Soomin Ham (KAIST)*; Adil Karjauv (KAIST); In So Kweon (KAIST)"
    },
    {
        title:"Is FGSM Optimal or Necessary for L∞ Adversarial Attack?",
        zoom:"https://illinois.zoom.us/j/84389427914?pwd=bGFMUSthb3BpT2RrTk1ZODI0R0EyZz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/30.pdf",
    },
    {
        title:"Chaoning Zhang (KAIST)*; Adil Karjauv (KAIST)*; Philipp Benz (KAIST)*; Soomin Ham (KAIST); Gyusang Cho (KAIST); Chan-Hyun Youn (KAIST); In So Kweon (KAIST)"
    },
    {
        title:"Backpropagating Smoothly Improves Transferability of Adversarial Examples",
        zoom:"https://illinois.zoom.us/j/82238740138?pwd=TWx6OXRBbnhxWVNxQWN4UXI0N1FkZz09",
        pdf:"https://aisecure-workshop.github.io/amlcvpr2021/cr/31.pdf",
    },
    {
        title:"Chaoning Zhang (KAIST)*; Philipp Benz (KAIST)*; Gyusang Cho (KAIST)*; Adil Karjauv (KAIST); Soomin Ham (KAIST); Chan-Hyun Youn (KAIST); In So Kweon (KAIST)"
    },
]
export default function Posters() {
    return <div className="page-posters">
            <div className="posters-title">Posters</div>
            <Row className="list-ul">
                <Col xl={40} span={30} className="list-li"> 
                <div className="title-top">
                    Paper Award Recipients
                </div>
                <div className="schedule-detail">
                    Best paper
                </div>
                <div className="list-two">
                    <span>On the Benefits of Defining Vicinal Distributions in Latent Space</span>
                </div>
                <div className="schedule-detail">
                    Distinguished papers
                </div>
                <div className="list-two">
                    <span>A Simple Fine-tuning Is All You Need: Towards Robust Deep Learning Via Adversarial Fine-tuning</span>                    
                </div>
                <div className="list-two">
                    <span>Adversarial Evaluation of Multimodal Models under Realistic Gray Box Assumptions</span>
                </div>
                <div className="list-two">
                    <span>Bit Error Robustness for Energy-Efficient DNN Accelerators</span>
                </div>
                <div className="list-two">
                    <span>Robustness Comparison of Vision Transformer and MLP-Mixer to CNNs</span>
                </div>
                <div className="list-two">
                    <span></span>
                </div>
                <div className="list-two">
                    <span></span>
                </div>
                <div className="list-two">
                    <span></span>
                </div>
                <div className="list-two">
                    <span></span>
                </div>
                <div className="title-top">
                    Date: June 19 
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                    Time: 14:15 - 15:00 PT
                </div>
                <div className="schedule-detail">
                    Updates: We will have another poster session at 17:00 - 17:45 PT in the breakout rooms in the <a href="https://berkeley.zoom.us/j/93687925763?pwd=blZ6dzZCVVRvM1RUdXYxOWUvYUtHZz09">Zoom</a> room of the main workshop.
                </div>
                <div className="title-top"></div>
                {arrs.map((item, index) => {
                    if (item.pdf) {
                        return <div className="list-two" key={index}>
                            <span>{item.title}</span>
                            <div><a href={item.zoom}>Zoom</a></div>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <div><a href={item.pdf}>PDF</a></div>
                        </div>
                    } else {
                        return <div className="list-one" key={index}>
                            <span>{item.title}</span>
                        </div>
                    }
                })}
                </Col>
            </Row>
        </div>
}
